import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorPurple = createSvgIcon(
  <circle cx="10" cy="10" fill="#800080" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorBlack',
);
